<div class="form-horizontal" #hostSettingsForm="ngForm" ngForm="hostSettingsForm">
	<div class="form-group row" [ngClass]=" form?.control?.get('eventAdmins')?.pristine ||
			form?.control?.get('eventAdmins')?.valid ? 'required' : ''">
		<label class="control-label col-sm-3">
			{{ ( webcast.videoSource === WebcastVideoSource.PRODUCER ?
				'Event_EventProducers' : 'Event_EventHosts'
			) | translate }}
		</label>
		<div class="col-sm-9">
			<div class="row">
				<div class="col-md-6 col-sm-9">
					<span class="help-block">
						{{ ( webcast.videoSource === WebcastVideoSource.PRODUCER ?
								'Event_EventProducerHostHelp' : 'Event_EventHostHelp'
							) | translate
						}}
					</span>
				</div>
			</div>
			<div class="row" *ngIf="eventAdminInsightOptions">
				<div class="col-md-6 col-sm-9">
					<ng-template #accessEntityOptionRow let-item="item" let-insight="insight">
						<access-entity-option-row [item]="item" [insight]="insight"></access-entity-option-row>
					</ng-template>

					<ng-template #accessEntityAssignedRow let-item="item" let-insight="insight">
						<access-entity-assigned-row [item]="item" [insight]="insight"></access-entity-assigned-row>
					</ng-template>
					<insight [attr.aria-label]="'Event_EventHosts' | translate" [insightOptions]="eventAdminInsightOptions" class="insight-listing" [(ngModel)]="webcast.eventAdmins" (ngModelChange)="validateMaxPresenters()" name="eventAdmins" #eventAdmins="ngModel" required [hidden]="hidden" [vbMaxLength]="maxAllowedEventHosts" [optionTemplate]="accessEntityOptionRow" [assignedTemplate]="accessEntityAssignedRow">
					</insight>
					<div class="required-field"></div>
				</div>

				<div *ngIf="eventAdmins.invalid" class="col-sm-7" role="alert" vbUiErrorMessage>
					@if (eventAdmins.errors.required) {
						{{ 'ThisFieldIsRequired' | translate }}
					} @else if (eventAdmins.errors.vbMaxLength) {
						{{ 'Event_EventHostCountError' | translate : { '0': maxAllowedEventHosts } }}
					} @else if (eventAdmins.errors.maxPresenters) {
						{{ 'Event_SelectEventPresentersErrorMessage' | translate : { '0' : maxAllowedCombinedPresentersAndHosts } }}
					}
				</div>
			</div>
		</div>
	</div>

	<div class="form-group row" *ngIf="webcast.videoSource === WebcastVideoSource.WEBRTC_SINGLE_PRESENTER && !isSidebar" [ngClass]="presenter?.pristine ? 'required': ''">
		<label class="control-label col-sm-3">{{ 'Event_Presenter' | translate }}</label>
		<div class="col-sm-9">
			<div class="row">
				<div class="col-md-6 col-sm-9">
					<vb-ui-single-user-select name="presenter" #presenter="ngModel" [(ngModel)]="webcast.presenter" required [searchQuery]="userSearchLoader">
					</vb-ui-single-user-select>
					<div class="required-field"></div>
				</div>
				<div *ngIf="presenter.invalid" class="col-sm-7" role="alert" vbUiErrorMessage>
					@if (presenter.errors.required) {
						{{ 'ThisFieldIsRequired' | translate }}
					}
				</div>
			</div>
			<div class="row">
				<div class="col-md-6 col-sm-9">
					<span class="help-block">{{ 'Event_Edit_PresenterHelp' | translate }}</span>
				</div>
			</div>
		</div>
	</div>

	<div class="form-group row" *ngIf="webcast.videoSource === WebcastVideoSource.PRODUCER && presenterInsightOptions" [ngClass]="producerPresenter?.pristine || producerPresenter?.valid ? 'required': ''">
		<label class="control-label col-sm-3">{{ 'Event_EventPresenters' | translate }}</label>
		<div class="col-sm-9">
			<div class="row">
				<div class="col-md-6 col-sm-9">
					<span class="help-block">{{ 'Event_SelectEventPresentersHelperText' | translate }}</span>
				</div>
			</div>
			<div class="row">
				<div class="col-md-6 col-sm-9">
					<ng-template #accessEntityOptionRow let-item="item" let-insight="insight">
						<access-entity-option-row [item]="item" [insight]="insight"></access-entity-option-row>
					</ng-template>

					<ng-template #accessEntityAssignedRow let-item="item" let-insight="insight">
						<access-entity-assigned-row [item]="item" [insight]="insight"></access-entity-assigned-row>
					</ng-template>
					<insight [attr.aria-label]="'Event_EventPresenters' | translate" [insightOptions]="presenterInsightOptions" class="insight-listing" [(ngModel)]="webcast.presenters" (ngModelChange)="validateMaxPresenters()" name="producerPresenter" #producerPresenter="ngModel" [optionTemplate]="accessEntityOptionRow" [assignedTemplate]="accessEntityAssignedRow" [hidden]="hidden">
					</insight>
				</div>
				<div *ngIf="producerPresenter.invalid" class="col-sm-7" role="alert" vbUiErrorMessage>
					@if (producerPresenter.errors.maxPresenters) {
						{{ 'Event_SelectEventPresentersErrorMessage' | translate : { '0' : maxAllowedCombinedPresentersAndHosts } }}
					}
				</div>
			</div>
		</div>
	</div>

	<div class="form-group row" *ngIf="features.enableExternalPresenters && webcast.videoSource === WebcastVideoSource.PRODUCER">
		<label class="control-label col-sm-3">{{ 'Event_ExternalPresenters' | translate }}</label>
		<div class="col-sm-9">
			<div class="row">
				<div class="col-md-6 col-sm-9">
					<edit-external-presenters #externalPresenters="ngModel" name="externalPresenters" ngModel ngDefaultControl [webcast]="webcast" (onAddRemove)="validateMaxPresenters()">
					</edit-external-presenters>
				</div>
				<div *ngIf="eventAdmins?.errors?.maxPresenters" class="col-sm-7" role="alert" vbUiErrorMessage>
					{{ 'Event_SelectEventPresentersErrorMessage' | translate : { '0' : maxAllowedCombinedPresentersAndHosts } }}
				</div>
			</div>
		</div>
	</div>

	<div class="form-group row" *ngIf="moderatorInsightOptions">
		<label class="control-label col-sm-3">{{ 'Event_Moderators' | translate }}</label>
		<div class="col-sm-9">
			<div class="row">
				<div class="col-md-6 col-sm-9">
					<ng-template #accessEntityOptionRow let-item="item" let-insight="insight">
						<access-entity-option-row [item]="item" [insight]="insight"></access-entity-option-row>
					</ng-template>

					<ng-template #accessEntityAssignedRow let-item="item" let-insight="insight">
						<event-moderator-assigned-row [item]="item" [insight]="insight"></event-moderator-assigned-row>
					</ng-template>
					<insight [attr.aria-label]="'Event_Moderators' | translate" [insightOptions]="moderatorInsightOptions" class="insight-listing" [(ngModel)]="webcast.moderators" name="moderators" [optionTemplate]="accessEntityOptionRow" [assignedTemplate]="accessEntityAssignedRow" [hidden]="hidden">
					</insight>
				</div>
			</div>
		</div>
	</div>
</div>
